import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ROUTE_CONTABILIDAD, ROUTE_HERRAMIENTAS } from '../constants/constant.model';

@Injectable({
  providedIn: 'root'
})
export class AsientoService {

  constructor(private apiService: ApiService,
    private http: HttpClient) {
  }


  generaDetalleAsientoApertura(periodo: any): Observable<any> {
    return this.http.get(environment.serviceUrl + "asiento-contable/genera-asiento-apertura/" + periodo, { observe: 'response' });
  }

  importarExcelDetalleAsientoApertura(data: any): Observable<any> {
    return this.http.post(environment.serviceUrl + "importaExcel/detalle-asiento-apertura", data, { observe: 'response' });
  }


  download_asiento_contabilizado(cia: any, periodo: any, mes: any, asiento: any, libro: any) {
    let fullUrl: any = null;

    fullUrl = environment.serviceUrl + `asiento-contable/reporte/contabilizado/${libro}/${periodo}/${mes}/${asiento}/format-default.pdf?` + "periodo=" + periodo + "&mes=" + mes + "&libro=" + libro + "&asiento=" + asiento;

    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }

  download_asiento_proceso(cia: any, periodo: any, mes: any, asiento: any, libro: any) {
    let fullUrl: any = null;

    fullUrl = environment.serviceUrl + `asiento-contable/reporte/contabilizado/${libro}/${periodo}/${mes}/${asiento}/asiento-proceso.pdf?` + "periodo=" + periodo + "&mes=" + mes + "&libro=" + libro + "&asiento=" + asiento;

    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }

  contabilizar(data: any): Observable<any> {
    this.apiService.setUrlPathApi(`asiento-contable` + `/contabilizar`);
    return this.apiService.executePutJson(data).pipe();
  }


  insertar(data: any): Observable<any> {
    this.apiService.setUrlPathApi(`asiento-contable`);
    return this.apiService.executePostJson(data).pipe();
  }

  contabilizarCalcular(data: any): Observable<any> {
    this.apiService.setUrlPathApi(`asiento-contable` + `/contabilizar/calcular`);
    return this.apiService.executePutJson(data).pipe();
  }

  buscar_asiento(libro: string, periodo: number, mes: number, situac: string, offset: any, limit: any): Observable<any> {
    this.apiService.setUrlPathApi(`asiento-contable` + `/asientos`);
    return this.apiService.execGetQueryJson(`/${libro}/${periodo}/${mes}?&offset=${offset}&limit=${limit}&situac=${situac}`).pipe();
  }

  getAsiento(libro: string, periodo: number, mes: number, asiento: any): Observable<any> {
    this.apiService.setUrlPathApi(`asiento-contable`);
    return this.apiService.execGetQueryJson(`/${libro}/${periodo}/${mes}/${asiento}`).pipe();
  }

  getLibrosAsiento(): Observable<any> {
    this.apiService.setUrlPathApi(`asiento-contable/libros`);
    return this.apiService.execGetQueryJson('').pipe();
  }

  getLibrosAsientosCajaChica(): Observable<any> {
    this.apiService.setUrlPathApi(`caja-chica-contable/libros`);
    return this.apiService.execGetQueryJson('').pipe();
  }

  descontabilizar(libro: string, periodo: number, mes: number, asiento: any): Observable<any> {
    this.apiService.setUrlPathApi(`asiento-contable` + `/descontabilizar/${libro}/${periodo}/${mes}/${asiento}`);
    return this.apiService.executePutJson(null).pipe();
  }

  anular(libro: string, periodo: number, mes: number, asiento: any, coduser: any): Observable<any> {
    this.apiService.setUrlPathApi(`asiento-contable` + `/anular/asiento/${libro}/${periodo}/${mes}/${asiento}?`);
    return this.apiService.executePutQueryParam(`coduser=${coduser}`).pipe();
  }

  exportarExcelAsiento(): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_HERRAMIENTAS.exportacion);
    return this.apiService.execGetQueryJsonPDF(`download-formato-detalle-asiento`).pipe();
  }
  exportarExcelDetalleAsiento(libro: any, periodo: any, mes: any, asiento: any): Observable<any> {
    this.apiService.setUrlPathApi('asiento-contable');
    return this.apiService.execGetQueryJsonPDF(`/exportar-detalle-excel/${libro}/${periodo}/${mes}/${asiento}`).pipe();
  }
  download_cheque_voucher(cia: any, periodo: any, mes: any, asiento: any, libro: any) {
    let fullUrl: any = null;

    fullUrl = environment.serviceUrl + `ctaporpagar/estadocuenta/reporte/chequevoucher/${libro}/${periodo}/${mes}/${asiento}/format-default.pdf?` + "periodo=" + periodo + "&mes=" + mes + "&libro=" + libro + "&asiento=" + asiento;

    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }

}